import { useEffect, useState } from 'react';
import Modal, { Media, Content } from 'components/Modal';
import Points from 'components/Points';
import { Offer } from 'models';
import { Alert, useMediaQuery, SnackbarContent } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import { theme } from 'assets/themes/zizzi';
import TermsAccordion from 'components/TermsAccordion';
import Steps from './Steps';

import {
  Title,
  Description,
  Footer,
  PurchaseButton,
  StyledMissingImage,
} from './PerkzStoreModal.styles';

const stepsToPurchase: string[] = [
  "Once you purchase this Perk, it will be added to your Perkz Wallet and you'll get a voucher code.",
  'Show the voucher code to a member of our team to redeem.',
];

export interface PerkzStoreModalProps {
  isOpen: boolean;
  onClose: () => void;
  offer: Offer;
  balance: number;
  onPurchase: () => void;
}

const PerkzStoreModal = ({ isOpen, onClose, offer, balance, onPurchase }: PerkzStoreModalProps) => {
  const [isAvailable, setIsAvailable] = useState(true);
  const { title, imageUrl, description, points = 1, isAlcohol } = offer;

  useEffect(() => {
    setIsAvailable(balance >= points);
  }, [points, balance]);

  const useFullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      fullScreen={useFullScreen}
      aria-label="Perkz Store Modal"
    >
      {imageUrl ? <Media image={imageUrl} /> : <StyledMissingImage />}
      <Content>
        <Title variant="h2">{title}</Title>
        <Description variant="h6">{description}</Description>
        {isAlcohol && (
          <SnackbarContent message="This perk cannot be redeemed in Republic of Ireland or Northern Ireland" />
        )}
        {isAvailable ? (
          <Steps steps={stepsToPurchase} />
        ) : (
          <Alert variant="filled" severity="info" icon={<InfoIcon />} aria-label="Item unavailable">
            Oops, you don&apos;t have enough Zs to purchase this Perk. Keep visiting to earn more
            Zs.
          </Alert>
        )}

        {offer.conditions && (
          <TermsAccordion conditions={offer.conditions} offerTitle={offer.title} />
        )}
      </Content>
      <Footer>
        <PurchaseButton fullWidth variant="contained" onClick={onPurchase} disabled={!isAvailable}>
          Purchase Perk
          <Points points={points} />
        </PurchaseButton>
      </Footer>
    </Modal>
  );
};

export default PerkzStoreModal;
